export default __webpack_public_path__ + "static/media/linkedin.f7ab10b0.jpeg";